<template>
<div class="recuperacion">
    <Menu />
    <div class="body">
        <div class="wrapper fadeInDown">
            
            <form id="formContent" @submit="recuperar" v-show="token == 0">
                <div class="pt-3">
                    <div class="fadeIn first">
                        <h2>{{msg}}</h2>
                    </div>
                    
                    <input type="email" id="password" class="fadeIn third" name="login" 
                    placeholder="Correo Electrónico" v-model="email" required>
                   
                    <div class="pt-2">
                       <button class="fadeIn fourth botonEntrar"> {{btnMsg}} </button>
                    </div>
                </div>
            </form>

            <form id="formContent" @submit="verificarToken" v-show="token != 0">
                <div class="pt-3">
                    <div class="fadeIn first">
                        <h2>{{msg}}</h2>
                    </div>
                    
                    <div class="container">
                      <p class="pt-4">
                        <button type="button" class="btn btn-dark btn-sm" data-toggle="tooltip" data-placement="right" :title="tooltip">
                          ?
                        </button>
                        <small> Requisitos para la contraseña </small>
                      </p>
                    </div>

                   <input type="password" class="fadeIn third" name="login" 
                    placeholder="Contraseña Nueva" v-model="pass1" required>
                    <input type="password" class="fadeIn third" name="login" 
                    placeholder="Repite la Contraseña" v-model="pass2" required>
                    <div class="pt-2">
                       <button class="fadeIn fourth botonEntrar"> {{btnMsg}} </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    
</div>
</template>



<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import Menu from '@/components/Menu'
import $ from 'jquery'

export default {
    components: {Menu},
    mixins: [ globalFunctions ],
    name: 'Recuperacion',
    data () {
        return {
            msg: '',
            btnMsg: 'Enviar',
            email: '',
            msg_alert: '',
            token: 0,
            pass1: '',
            pass2: '',
            tooltip: 'La clave debe tener al menos 8 caracteres, una letra minuscula, una mayuscula y un valor numérico'
        }
    },
    computed:{
        ...mapState(['url'])
    },
    methods:{
        recuperar(e){
            e.preventDefault();
            let data = {
                flag: 4,
                email: this.email
            }

            this.axios.post(this.url +'send_mails.php', data).then((responce) =>{
                console.log(responce.data);
                this.email = '';
                this.msjOk2('Enviamos a tu correo un enlace de recuperación');
            });
        },

        verificarToken(e){
            e.preventDefault();
            
            let data = {
                flag: 5,
                pass: this.pass1,
                token: this.token
            }
            
            if(this.pass1 == this.pass2){
                this.axios.post(this.url +'alta_usuario.php', data).then((responce) =>{
                    if(responce.data == 200){
                        this.msjOk('Contraseña Establecida');
                        this.$router.push("/Login");
                    }else{
                        this.msjError(responce.data);
                    }   
                });
            }else{
                this.msjError('Las contraseñas no coinciden');
            }
            
        }
    },
    mounted:function(){

        $("#warning-alert").hide();
        
        $('[data-toggle="tooltip"]').tooltip();

        if(this.$route.params.token == null){
            this.token = 0;
            this.msg = 'Ingresa tu correo electronico para recuperar tu contraseña';
        }else{
             this.token = this.$route.params.token;
             this.msg = 'Establece Tu Contraseña Nueva';
        }
    },
}
</script>

<style scoped>

    a {
        color: #92badd;
        display:inline-block;
        text-decoration: none;
    }

    h2 {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        display:inline-block;
        margin: 40px 8px 10px 8px; 
    }

    /* STRUCTURE */

    .wrapper {
        display: flex;
        align-items: center;
        flex-direction: column; 
        justify-content: center;
        width: 100%;
        min-height: 100%;
        padding: 20px;
    }

    .wrapperH {
        display: flex;
        align-items: center;
        flex-direction: row; 
        justify-content: center;
        width: 100%;
        min-height: 100%;
        padding: 20px;
    }

    #formContent {
        -webkit-border-radius: 10px 10px 10px 10px;
        border-radius: 10px 10px 10px 10px;
        background: #fff;
        padding: 30px;
        width: 90%;
        max-width: 450px;
        position: relative;
        padding: 0px;
        -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
        box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
        text-align: center;
    }

    #formFooter {
        background-color: #f6f6f6;
        border-top: 1px solid #dce8f1;
        padding: 25px;
        text-align: center;
        -webkit-border-radius: 0 0 10px 10px;
        border-radius: 0 0 10px 10px;
    }

    /* FORM TYPOGRAPHY*/

    .botonEntrar{
        background-color: #ff573b;
        border: none;
        color: white;
        padding: 15px 80px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 13px;
        -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
        box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
        -webkit-border-radius: 5px 5px 5px 5px;
        border-radius: 5px 5px 5px 5px;
        margin: 5px 20px 40px 20px;
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
    }

    input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
        -moz-transform: scale(0.95);
        -webkit-transform: scale(0.95);
        -o-transform: scale(0.95);
        -ms-transform: scale(0.95);
        transform: scale(0.95);
    }
    input[type=text]{
        background-color: #f6f6f6;
        border: none;
        color: #0d0d0d;
        padding: 15px 32px;
        text-align: center;
        text-decoration: none;
        margin: 0px 0px 0px 35px;
        font-size: 16px;
        border: 2px solid #f6f6f6;
        -webkit-transition: all 0.5s ease-in-out;
        -moz-transition: all 0.5s ease-in-out;
        -ms-transition: all 0.5s ease-in-out;
        -o-transition: all 0.5s ease-in-out;
        transition: all 0.5s ease-in-out;
        -webkit-border-radius: 5px 5px 5px 5px;
        border-radius: 5px 5px 5px 5px;
    }
    input[type=password], input[type=email] {
        background-color: #f6f6f6;
        border: none;
        color: #0d0d0d;
        padding: 15px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        margin: 5px;
        width: 85%;
        border: 2px solid #f6f6f6;
        -webkit-transition: all 0.5s ease-in-out;
        -moz-transition: all 0.5s ease-in-out;
        -ms-transition: all 0.5s ease-in-out;
        -o-transition: all 0.5s ease-in-out;
        transition: all 0.5s ease-in-out;
        -webkit-border-radius: 5px 5px 5px 5px;
        border-radius: 5px 5px 5px 5px;
    }

    input[type=text]:focus, input[type=password]:focus {
        background-color: #fff;
        border-bottom: 2px solid #ff573b;;
    }

    input[type=text]:placeholder, input[type=password]:placeholder {
        color: #cccccc;
    }

    /* ANIMATIONS */

    /* Simple CSS3 Fade-in-down Animation */
    .fadeInDown {
        -webkit-animation-name: fadeInDown;
        animation-name: fadeInDown;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    @-webkit-keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }
    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
    }

    @keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }
    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
    }

    /* Simple CSS3 Fade-in Animation */
    @-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
    @-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
    @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

    .fadeIn {
        opacity:0;
        -webkit-animation:fadeIn ease-in 1;
        -moz-animation:fadeIn ease-in 1;
        animation:fadeIn ease-in 1;

        -webkit-animation-fill-mode:forwards;
        -moz-animation-fill-mode:forwards;
        animation-fill-mode:forwards;

        -webkit-animation-duration:1s;
        -moz-animation-duration:1s;
        animation-duration:1s;
    }

    .fadeIn.first {
        -webkit-animation-delay: 0.4s;
        -moz-animation-delay: 0.4s;
        animation-delay: 0.4s;
    }

    .fadeIn.second {
        -webkit-animation-delay: 0.6s;
        -moz-animation-delay: 0.6s;
        animation-delay: 0.6s;
    }

    .fadeIn.third {
        -webkit-animation-delay: 0.8s;
        -moz-animation-delay: 0.8s;
        animation-delay: 0.8s;
    }

    .fadeIn.fourth {
        -webkit-animation-delay: 1s;
        -moz-animation-delay: 1s;
        animation-delay: 1s;
    }

    /* Simple CSS3 Fade-in Animation */
    .underlineHover:after {
        display: block;
        left: 0;
        bottom: -10px;
        width: 0;
        height: 2px;
        background-color: #56baed;
        content: "";
        transition: width 0.2s;
    }

    .underlineHover:hover {
        color: #0d0d0d;
    }

    .underlineHover:hover:after{
        width: 100%;
    }

    /* OTHERS */

    *:focus {
        outline: none;
    } 

    #icon {
        width:60%;
    }

</style>




// WEBPACK FOOTER //
// src/views/Recuperacion/Recuperacion.vue